import React from 'react';
import { ReconcileEditUIProvider } from './ReconcileEditUIContext';

import { ReconcileEdit } from './reconcile-edit-form/ReconcileEdit';
import { DonationDetailUIProvider } from './reconcile-edit-form/ReconcileDetailUIContext';

export function ReconcileEditPage({ history, match: { params: { id } } }) {
	const donationUIEvents = {
		newDonaturButtonClick: () => {
			history.push('/donatur/new');
		},
	};
	return (
		<ReconcileEditUIProvider currentReconcileId={id} history={history} donationUIEvents={donationUIEvents}>
			<DonationDetailUIProvider>
				<ReconcileEdit history={history} id={id} />
			</DonationDetailUIProvider>
		</ReconcileEditUIProvider>
	);
}

